import { render } from "./PrivacyPopup.vue?vue&type=template&id=578cb712"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js"
script.render = render

export default script